'use client';

import { useEffect } from 'react';
import { captureBoundaryError } from '@/lib/captureError';

/**
 * Last-resort boundary: catches errors thrown in the root layout itself
 * (which app/[lang]/error.tsx cannot, since it renders inside the layout).
 * Replaces the whole document, so it ships its own <html>/<body> and uses
 * inline styles (global CSS may not be available here).
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureBoundaryError(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
          background: '#f7f7f7',
          color: '#333',
        }}
      >
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            textAlign: 'center',
          }}
        >
          <h2 style={{ fontSize: '28px', fontWeight: 500, marginBottom: '12px' }}>
            Something went wrong
          </h2>
          <p style={{ maxWidth: '28rem', color: '#666', marginBottom: '28px' }}>
            We encountered an unexpected error. Please try again or return to the homepage.
          </p>
          <button
            onClick={reset}
            style={{
              background: '#D92B03',
              color: '#fff',
              border: 0,
              borderRadius: '6px',
              padding: '12px 24px',
              fontSize: '13px',
              fontWeight: 700,
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            Try Again
          </button>
        </div>
      </body>
    </html>
  );
}
